// removed by extract-text-webpack-plugin
module.exports = {"spinner":"MyLittleSpinner__spinner__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/MyLittleSpinner/MyLittleSpinner.scss
// module id = 177
// module chunks = 0